module.exports = __webpack_public_path__ + "img/pact.3cbf4f14.png";